import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import Constante from "Constante.json";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import dayjs from "dayjs";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EmpresaPessoaApp from "../../ERP/EmpresaPessoa/EmpresaPessoaApp";
import AgendamentoEdicaoDialog from "./AgendamentoEdicaoDialog";
import AgendamentoEdicaoFactory from "./AgendamentoEdicaoFactory";
import * as Actions from "./Store/Actions/AgendamentoEdicaoActions";
import reducer from "./Store/Reducers/AgendamentoEdicaoReducer";

const styles = (theme) => ({
   root: {
      color: theme.palette.text.primary,
   },
   actionBar: {
      position: "absolute",
      bottom: 0,
      height: 52,
      display: "flex",
      width: "100%",
      alignItems: "center",
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.secondary,
   },
});

const TIPOS_AGENDAMENTO = [
   { "id": 1, "value": "Agendamento", "tipoprocesso": 203 }, //medico
   { "id": 2, "value": "Bloqueio" },
   { "id": 3, "value": "Evento" },
   { "id": 4, "value": "Oportunidade" },
   { "id": 5, "value": "Contrato", "tipoprocesso": 403 }, //imovel
   { "id": 6, "value": "Agendamento", "tipoprocesso": 603 }, //barber
   { "id": 7, "value": "Agendamento", "tipoprocesso": 703 }, //beauty
   { "id": 8, "value": "Agendamento", "tipoprocesso": 803 }, //crm
   { "id": 9, "value": "Agendamento", "tipoprocesso": 903 }, //odonto
];

const NewState = {
   idagendamento: null,
   inicio: dayjs().format("YYYY-MM-DD HH:mm"),
   termino: dayjs().format("YYYY-MM-DD HH:mm"),
   idpessoaformulariolocal: null,
   preatendimento: {},
   responsaveis: [],
   responsaveisLookup: [],
   clientes: [],
   clientesLookup: [],
   tipo: -1,
   titulo: "",
   idpessoa: null,
   tags: "",
   observacao: "",
   tabValue: 0,
   anotacoes: [],
   idparent: null,
   origem: null,
   tipoprocesso: null
};

class AgendamentoEdicaoApp extends XAPPComponent {

   state = { ...NewState };

   componentDidMount() {
      if (this.props.openAutomatic) {
         this.openDialog();
      }
   }

   componentDidUpdate(prevProps, prevState) {
      if (this.props.AgendamentoEdicao.error) {
         this.props.showMessage({
            message: this.props.AgendamentoEdicao.error,
            variant: "error",
         });
         this.props.AgendamentoEdicao.error = null;
      }
      if (this.props.AgendamentoEdicao.warning) {
         this.props.showMessage({
            message: this.props.AgendamentoEdicao.warning,
            variant: "warning",
         });
         this.props.AgendamentoEdicao.warning = null;
      }
      if (this.props.AgendamentoEdicao.info) {
         this.props.showMessage({
            message: this.props.AgendamentoEdicao.info,
            variant: "success",
         });
         this.props.AgendamentoEdicao.info = null;
      }

      const form = this.state;
      const { dadosresponsavel, HorarioAgendado, idparent = null, dialog = null, idagendamento = null, xappRouteParams, getBaseFiltro, tipo, getHorarioAgendado, } = this.props;

      if (!_.isNull(dialog) && !_.isEqual(dialog, prevProps.dialog) && !_.isUndefined(dialog[idagendamento]) && !_.isNull(dialog[idagendamento])) {
         getBaseFiltro(xappRouteParams);

         if (Object.keys(dialog[idagendamento]).length > 0) {
            let AObj = Object.assign({}, this.state, dialog[idagendamento]);
            AObj.tabValue = this.checkExistsContent(this.props.openContent);
            AObj.tipo = tipo;
            AObj.tags = dialog[idagendamento].agendamentotag;
            AObj.preatendimento.videoChamada = dialog[idagendamento].preatendimento?.videoChamada ?? false;
            // AGENDAMENTO APARTIR DE OPORTUNIDADE
            if (!_.isNull(idparent)) {
               AObj.idparent = idparent;
            }

            if (!_.isUndefined(dialog[idagendamento].inicio) && !_.isNull(dialog[idagendamento].inicio)) {
               AObj.inicio = dayjs(dialog[idagendamento].inicio).format("YYYY-MM-DD HH:mm:ss");
            }
            if (!_.isUndefined(dialog[idagendamento].termino) && !_.isNull(dialog[idagendamento].termino)) {
               AObj.termino = dayjs(dialog[idagendamento].termino).format("YYYY-MM-DD HH:mm:ss");
            }
            if (!_.isUndefined(dialog[idagendamento].responsaveis) && !_.isNull(dialog[idagendamento].responsaveis)) {
               AObj.responsaveis = [];
               AObj.responsaveisLookup = [];
               dialog[idagendamento].responsaveis.forEach((item) => {
                  AObj.responsaveis.push(item.idpessoaformulario);
                  AObj.responsaveisLookup.push({ ...item, id: item.idpessoaformulario, label: item.nome });
               });
            }
            if (!_.isUndefined(dialog[idagendamento].clientes) && !_.isNull(dialog[idagendamento].clientes)) {
               AObj.clientes = [];
               AObj.clientesLookup = [];
               dialog[idagendamento].clientes.forEach((item) => {
                  AObj.clientes.push(item.idpessoaformulario);
                  AObj.clientesLookup.push({ ...item, id: item.idpessoaformulario, label: item.nome });
               });
            }
            if (!_.isUndefined(dialog[idagendamento].preatendimento) && !_.isUndefined(dialog[idagendamento].preatendimento.pedido) && !_.isNull(dialog[idagendamento].preatendimento.pedido)) {
               dialog[idagendamento].preatendimento.pedido.forEach((item, x) => {
                  AObj.preatendimento.pedido[x] = { ...item, value: item.idpessoaformulario, label: item.nome };
               });
            }
            this.setState(AObj);
         }
      }

      if (!_.isNull(HorarioAgendado) && !_.isUndefined(HorarioAgendado[idagendamento])) {
         let APrev = !_.isNull(prevProps.HorarioAgendado) ? prevProps.HorarioAgendado : {};

         if (!_.isUndefined(APrev[idagendamento]) && !_.isEqual(APrev[idagendamento], HorarioAgendado[idagendamento])) {
            this.handleChange({ target: { name: "inicio", value: dayjs(HorarioAgendado[idagendamento][0].inicio).format("YYYY-MM-DD HH:mm:ss") } });
         }
      }

      if (!_.isNull(form.responsaveis) && form.responsaveis.length > 0 && !_.isEqual(prevState.responsaveis, form.responsaveis)) {
         getHorarioAgendado(xappRouteParams, form, idagendamento, this.getStepAgendamento());
      }

      if (!_.isNull(dialog) && !_.isUndefined(dialog[idagendamento]) && !_.isNull(dialog[idagendamento])) {
         if (!_.isNull(dadosresponsavel) && !_.isEqual(prevProps.dadosresponsavel, dadosresponsavel)) {
            let AArray = [];
            dadosresponsavel.forEach((item) => {
               AArray.push({
                  ...item,
                  id: item.idpessoaformulario,
                  label: item.nome,
                  observacao: item.formulario.observacao,
                  registroconselho: item.formulario.registroconselho,
                  registroconselhouf: item.formulario.registroconselhouf,
                  registroespecialista: item.formulario.registroespecialista,
                  registroespecialistauf: item.formulario.registroespecialistauf,
               });
            });
            this.setState(_.set({ ...this.state }, "responsaveisLookup", AArray));
         }
      }

      if ((_.isUndefined(form.preatendimento.idfontepagadora) || _.isNull(form.preatendimento.idfontepagadora)) &&
         !_.isNull(form.clientes) &&
         form.clientes.length === 1 &&
         !_.isEqual(prevState.clientes, form.clientes)
      ) {
         this.handleLookupFontePagadora(form.clientesLookup);
      }

      if (!_.isNull(dialog) && Object.keys(dialog).length === 0 && !_.isEqual(dialog, prevProps.dialog)) {
         this.setState(_.set({ ...NewState }, "responsaveis", []));
         this.props.clearReducer();
      }
   }

   handleChange = (ev) => {
      this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
   };

   handleChangeCheck = (ev) => {
      this.setState(_.set({ ...this.state }, ev.target.name, ev.target.checked));
   };

   checkExistsContent = _AContent => {
      const AContents = {
         "principal": 0,
         "cliente": 1,
         "pedido": 2,
         "profissional": 3,
         "oportunidade": 4,
         "arquivo": 5,
      };

      if (!_.isUndefined(AContents[_AContent])) {
         return AContents[_AContent];
      }
      return 0;
   };

   handleChangeAnotacoes = (_AAnotacao) => {
      let AArray = Object.assign([], this.state.anotacoes);
      let AIndex = _.findIndex(AArray, { id: _AAnotacao.id });
      if (AIndex === -1) {
         AArray.push(_AAnotacao);
      } else {
         AArray.splice(AIndex, 1, _AAnotacao);
      }
      this.setState(_.set({ ...this.state }, "anotacoes", AArray));
   };

   handleChangeHorarios = (_AInicio, _ATermino) => {
      let AObj = Object.assign({}, this.state);
      AObj.inicio = _AInicio;
      AObj.termino = _ATermino;
      this.setState(AObj);
   };

   handleChangeMulti = (ev) => {
      this.setState(_.set({ ...this.state }, ev.target.name, [ev.target.value]));
   };

   handleChangeData = (ev) => {
      const form = this.state;
      const { idagendamento, getHorarioAgendado, xappRouteParams } = this.props;
      this.setState({ "inicio": ev.target.value, "termino": null });
      getHorarioAgendado(xappRouteParams, { ...form, "inicio": ev.target.value }, idagendamento, this.getStepAgendamento());
   };

   getHorarioAgendadoAll = () => {
      const form = this.state;
      const { idagendamento, getHorarioAgendado, xappRouteParams } = this.props;
      getHorarioAgendado(xappRouteParams, { ...form, allResponsaveis: 1 }, idagendamento, this.getStepAgendamento());
   };

   getStepAgendamento = () => {
      const { xappRouteParams, user } = this.props;
      if (!_.isUndefined(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao)) {
         let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "INTERVALO_AGENDA" });
         if (!_.isUndefined(AConfig)) {
            return Number(AConfig.valor);
         }
      }
      return Constante.step_agendamento;
   };

   canBeSubmitted = () => {
      const { idpessoaformulariolocal, inicio, termino, clientes, status, responsaveis, tipo, preatendimento } = this.state;
      switch (tipo) {
         case 1:
            return (
               !_.isUndefined(preatendimento.idfontepagadora) &&
               !_.isNull(preatendimento.idfontepagadora) &&
               !_.isUndefined(preatendimento.pedido) &&
               !_.isNull(preatendimento.pedido) &&
               preatendimento.pedido.length > 0 &&
               !_.isNull(clientes) &&
               clientes.length === 1 &&
               !_.isNull(responsaveis) &&
               responsaveis.length > 0 &&
               !_.isNull(inicio) &&
               !_.isNull(termino) &&
               inicio != termino &&
               ![4, 5, 6, 7, 9, 10, 12].includes(status)
            );
         case 2:
            return (
               !_.isNull(inicio) &&
               !_.isNull(termino) &&
               ![5, 6, 7].includes(status)
            );
         case 3:
            return (
               !_.isNull(idpessoaformulariolocal) &&
               !_.isUndefined(preatendimento.idfontepagadora) &&
               !_.isNull(preatendimento.idfontepagadora) &&
               !_.isNull(clientes) &&
               clientes.length > 0 &&
               !_.isNull(responsaveis) &&
               responsaveis.length > 0 &&
               !_.isNull(inicio) &&
               !_.isNull(termino)
            );
         case 4:
            return (
               !_.isUndefined(preatendimento.pedido) &&
               !_.isNull(preatendimento.pedido) &&
               preatendimento.pedido.length > 0 &&
               !_.isNull(clientes) &&
               clientes.length === 1 &&
               !_.isNull(responsaveis) &&
               responsaveis.length > 0
            );
         case 5:
            return (
               !_.isUndefined(preatendimento.idfontepagadora) &&
               !_.isNull(preatendimento.idfontepagadora) &&
               !_.isUndefined(preatendimento.pedido) &&
               !_.isNull(preatendimento.pedido) &&
               preatendimento.pedido.length > 0 &&
               !_.isNull(clientes) &&
               clientes.length === 1 &&
               !_.isNull(responsaveis) &&
               responsaveis.length > 0 &&
               !_.isNull(inicio) &&
               !_.isNull(termino)
            );
         default:
            return (
               !_.isNull(responsaveis) &&
               responsaveis.length > 0 &&
               !_.isNull(inicio) &&
               !_.isNull(termino)
            );
      }
   };

   getEmpresaClienteLookup = (_AChange) => {
      return (
         <EmpresaPessoaApp
            xappRouteParams={this.props.xappRouteParams}
            isLookup={true}
            multiSelect={true}
            onChange={_AChange}
            id="NovoAgendamentoCliente"
            key="NovoAgendamentoCliente"
         />
      );
   };

   handleLookupClientes = (_AValue) => {
      let AClientes = [];
      let AClientesLookup = [];
      if (_AValue) {
         _AValue.forEach((item) => {
            AClientes.push(item.idpessoaformulario);
            AClientesLookup.push({ ...item });
         });
      }
      this.setState({ clientes: AClientes, clientesLookup: AClientesLookup });
   };

   getEmpresaFontePagadoraLookup = (_AChange) => {
      return (
         <EmpresaPessoaApp
            xappRouteParams={this.props.xappRouteParams}
            isLookup={true}
            multiSelect={false}
            onChange={_AChange}
            id="NovoAgendamentoFontePagadora"
            key="NovoAgendamentoFontePagadora"
         />
      );
   };

   handleLookupFontePagadora = (_AValue) => {
      if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
         let AItem = _AValue[_AValue.length - 1];
         this.setState(
            _.set({ ...this.state }, "preatendimento", {
               ...this.state.preatendimento,
               idfontepagadora: AItem.idpessoaformulario,
               fontepagadoranome: AItem.nome,
            })
         );
      } else {
         this.setState(_.set({ ...this.state }, "preatendimento", { ...this.state.preatendimento, idfontepagadora: null, fontepagadoranome: null }));
      }
   };

   handleChangePreAtendimento = (_AName, _AValue) => {
      this.setState({ preatendimento: _.set({ ...this.state.preatendimento }, _AName, _AValue) });
   };

   getProdutos = () => {
      let AResponse = [];
      const { EmpresaPessoaProduto = null } = this.props;
      const form = this.state;
      let AResponsaveis = [];
      if (!_.isUndefined(form.responsaveis) && !_.isNull(form.responsaveis)) {
         AResponsaveis = form.responsaveis.join().split(", ");
      }

      if (!_.isNull(EmpresaPessoaProduto)) {
         EmpresaPessoaProduto.forEach((item) => {
            if (!_.isNull(item.idproduto) &&
               (AResponse.length === 0 || _.findIndex(AResponse, { idpessoaformulario: item.idproduto }) === -1) &&
               ((AResponsaveis.length === 0 || AResponsaveis.includes(item.idpessoaformulario)))
            ) {
               AResponse.push({
                  ...item,
                  value: item.idproduto,
                  idpessoaformulario: item.idproduto,
                  label: item.produtonomevalor,
                  nome: item.produtonome,
                  qtdprofissionais: item.qtdprofissionais,
               });
            }
         });
      }
      return AResponse;
   };

   handleProdutos = (_AValue) => {
      let APreAtendimento = Object.assign({}, this.state.preatendimento);
      APreAtendimento.pedido = [];
      if (_AValue) {
         _AValue.forEach((item) => {

            let ADescricaoComercial = "";
            if (!_.isUndefined(item.descricaocomercial) && !_.isNull(item.descricaocomercial)) {
               ADescricaoComercial = item.descricaocomercial;
            }
            else if (
               !_.isUndefined(item.produtoformulario) &&
               !_.isNull(item.produtoformulario) &&
               !_.isUndefined(item.produtoformulario.descricaocomercial) &&
               !_.isNull(item.produtoformulario.descricaocomercial)) {
               ADescricaoComercial = item.produtoformulario.descricaocomercial;
            }

            let AOrientacao = "";
            if (!_.isUndefined(item.orientacao) && !_.isNull(item.orientacao)) {
               AOrientacao = item.orientacao;
            }
            else if (
               !_.isUndefined(item.produtoformulario) &&
               !_.isNull(item.produtoformulario) &&
               !_.isUndefined(item.produtoformulario.orientacao) &&
               !_.isNull(item.produtoformulario.orientacao)) {
               AOrientacao = item.produtoformulario.orientacao;
            }


            let AItem = {
               value: item.value,
               label: item.label,
               idpessoaformulario: item.idpessoaformulario,
               nome: item.nome || item.produtonome,
               valor: item.valor || item.produtovalor,
               quantidade: 1,
               acrescimo: 0,
               desconto: 0,
               qtdprofissionais: item.qtdprofissionais,
               valordescricao: item.produtovalordescricao,
               descricaocomercial: ADescricaoComercial,
               orientacao: AOrientacao
            };
            APreAtendimento.pedido.push(AItem);
         });
      }
      this.setState({ preatendimento: APreAtendimento });
   };

   getResponsaveis = () => {
      let AResponse = [];
      const { EmpresaPessoaProduto = null } = this.props;
      const form = this.state;

      if (!_.isNull(EmpresaPessoaProduto)) {
         let AArrayPessoa = [];

         EmpresaPessoaProduto.forEach((item) => {
            if (_.findIndex(AArrayPessoa, { idpessoaformulario: item.idpessoaformulario }) === -1) {
               AArrayPessoa.push(item);
            }
         });

         AArrayPessoa.forEach((pessoa) => {
            let AOK = true;
            if (!_.isUndefined(form.preatendimento.pedido) && form.preatendimento.pedido.length !== 0) {
               form.preatendimento.pedido.forEach((produto) => {
                  if (
                     AOK &&
                     _.findIndex(EmpresaPessoaProduto, { idpessoaformulario: pessoa.idpessoaformulario, idproduto: produto.idpessoaformulario }) === -1
                  ) {
                     AOK = false;
                  }
               });
            }
            if (AOK) {
               AResponse.push({
                  value: pessoa.idpessoaformulario,
                  idpessoaformulario: pessoa.idpessoaformulario,
                  label: pessoa.nome,
                  nome: pessoa.nome,
               });
            }
         });
         return AResponse;
      }
   };

   handleResponsaveis = (_AValue) => {
      let AState = Object.assign({}, this.state);
      let AResponsaveis = [];
      if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
         let AItem = _AValue[_AValue.length - 1];
         AResponsaveis.push(AItem.idpessoaformulario);
      }
      AState.responsaveis = AResponsaveis;
      if (AResponsaveis.length === 0) {
         AState.responsaveisLookup = [];
         this.props.AgendamentoEdicao.dadosresponsavel = null;
      }
      this.setState({ ...AState });
   };

   openDialog = () => {
      const { idagendamento = null, get, xappRouteParams, openDialog, sugerido = null, tipo, origem } = this.props;
      if (!_.isNull(idagendamento) && !("" + idagendamento).includes("new_")) {
         get(idagendamento, xappRouteParams);
      } else {
         this.setState(_.set({
            ...NewState,
            "tipo": tipo,
            "origem": origem,
            "tipoprocesso": _.findIndex(TIPOS_AGENDAMENTO, { id: tipo }) !== -1 ? _.find(TIPOS_AGENDAMENTO, { id: tipo })?.tipoprocesso : null
         }));
         openDialog(idagendamento, !_.isNull(sugerido) ? sugerido : {});
      }
   };

   checkHorarioDisponivel = (_AInicio, _ATermino, _ACampo = null) => {
      const form = this.state;
      const { HorarioAgendado, idagendamento, xappRouteParams, user } = this.props;
      let AResponse = true;

      let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "AGENDAMENTO_SIMULTANEO" });
      if (!_.isUndefined(AConfig) && String(AConfig.valor).toLowerCase() === "true") {
         return true;
      }

      if (!_.isNull(_ACampo) && !_.isNull(form.idagendamento)) {
         return false;
      }

      if (_ACampo === "inicio" && !_.isNull(HorarioAgendado) && !_.isUndefined(HorarioAgendado[idagendamento])) {
         const AItem = _.find(HorarioAgendado[idagendamento], x => new Date(x.inicio).getTime() === new Date(_AInicio).getTime());
         AResponse = !_.isUndefined(AItem) && _.isNull(AItem.idagendamento);
      }

      if (_ACampo === "termino" && !_.isNull(HorarioAgendado) && !_.isUndefined(HorarioAgendado[idagendamento])) {

         let AData = dayjs(form.inicio).format("YYYY-MM-DD");
         HorarioAgendado[idagendamento].forEach((item) => {
            if (
               (!_.isNull(item.idagendamento) ||
                  new Date(item.inicio).getTime() === new Date(AData + " " + _ATermino).getTime()) &&
               new Date(item.inicio).getTime() > new Date(_AInicio).getTime() &&
               new Date(item.inicio).getTime() + item.duracao < new Date(AData + " " + _ATermino).getTime()
            ) {
               AResponse = false;
            }
         });

         if (new Date(_AInicio).getTime() >= new Date(AData + " " + _ATermino).getTime()) {
            AResponse = false;
         }
      }
      return AResponse;
   };

   showWebex = () => {
      const form = this.state;
      let AShowWebex = false;
      if (!_.isNull(form.responsaveisLookup) && form.responsaveisLookup.length === 1 && !_.isNull(form.responsaveisLookup[0].configuracao)) {
         let AConfigWebex = _.find(form.responsaveisLookup[0].configuracao, { "chave": "TELEMEDICINA_WEBEX" });
         if (!_.isUndefined(AConfigWebex)) {
            AShowWebex = Boolean(AConfigWebex.valor);
         }
      }
      return AShowWebex;
   };

   canScheduleWebex = () => {
      const form = this.state;
      let AShowWebex = this.showWebex();

      return (
         !_.isNull(form.idagendamento) && AShowWebex &&
         !_.isNull(form.responsaveis) && form.responsaveis.length === 1 &&
         !_.isNull(form.clientes) && form.clientes.length > 0 &&
         !_.isNull(form.inicio) && form.inicio.length > 0 &&
         !_.isNull(form.termino) && form.termino.length > 0
      );
   };

   render() {
      const form = this.state;
      const { view, idagendamento = "new_" + view, TagsPessoa, openContent, user, getBaseFiltro, tipo, isDialog = false, children = null, get, saveAgendamentoPessoa, xappRouteParams, EmpresaStatus, EmpresaLocais, HorarioAgendado, save, TagsAgendamento, callback, className = null } = this.props;

      return (
         <React.Fragment>
            {isDialog ? (
               <React.Fragment>
                  {!_.isNull(children) &&
                     <div className={clsx(!_.isNull(className) ? className : "w-fit", "cursor-pointer")} onClick={() => this.openDialog()}>
                        {children}
                     </div>
                  }
                  <AgendamentoEdicaoDialog
                     idagendamento={idagendamento}
                     handleChange={this.handleChange}
                     handleChangeCheck={this.handleChangeCheck}
                     handleChangeHorarios={this.handleChangeHorarios}
                     handleChangeMulti={this.handleChangeMulti}
                     handleLookupClientes={this.handleLookupClientes}
                     handleProdutos={this.handleProdutos}
                     handleResponsaveis={this.handleResponsaveis}
                     handleChangeData={this.handleChangeData}
                     handleLookupFontePagadora={this.handleLookupFontePagadora}
                     getEmpresaFontePagadoraLookup={this.getEmpresaFontePagadoraLookup}
                     getEmpresaClienteLookup={this.getEmpresaClienteLookup}
                     getProdutos={this.getProdutos}
                     getResponsaveis={this.getResponsaveis}
                     checkHorarioDisponivel={this.checkHorarioDisponivel}
                     handleChangeAnotacoes={this.handleChangeAnotacoes}
                     canBeSubmitted={this.canBeSubmitted}
                     getHorarioAgendadoAll={this.getHorarioAgendadoAll}
                     handleChangePreAtendimento={this.handleChangePreAtendimento}
                     canScheduleWebex={this.canScheduleWebex}
                     showWebex={this.showWebex}
                     TIPOS_AGENDAMENTO={TIPOS_AGENDAMENTO}
                     EmpresaLocais={EmpresaLocais}
                     EmpresaStatus={EmpresaStatus}
                     HorarioAgendado={HorarioAgendado}
                     TagsAgendamento={TagsAgendamento}
                     TagsPessoa={TagsPessoa}
                     xappRouteParams={xappRouteParams}
                     getBaseFiltro={getBaseFiltro}
                     saveAgendamentoPessoa={saveAgendamentoPessoa}
                     view={view}
                     form={form}
                     get={get}
                     save={save}
                     tipo={tipo}
                     callback={callback}
                     user={user}
                     openContent={openContent}
                  />
               </React.Fragment>
            ) : (
               <AgendamentoEdicaoFactory
                  idagendamento={idagendamento}
                  handleChange={this.handleChange}
                  handleChangeCheck={this.handleChangeCheck}
                  handleChangeHorarios={this.handleChangeHorarios}
                  handleChangeMulti={this.handleChangeMulti}
                  handleLookupClientes={this.handleLookupClientes}
                  handleProdutos={this.handleProdutos}
                  handleResponsaveis={this.handleResponsaveis}
                  handleChangeData={this.handleChangeData}
                  getEmpresaClienteLookup={this.getEmpresaClienteLookup}
                  getProdutos={this.getProdutos}
                  getResponsaveis={this.getResponsaveis}
                  checkHorarioDisponivel={this.checkHorarioDisponivel}
                  handleChangeAnotacoes={this.handleChangeAnotacoes}
                  canBeSubmitted={this.canBeSubmitted}
                  getHorarioAgendadoAll={this.getHorarioAgendadoAll}
                  handleChangePreAtendimento={this.handleChangePreAtendimento}
                  canScheduleWebex={this.canScheduleWebex}
                  showWebex={this.showWebex}
                  TIPOS_AGENDAMENTO={TIPOS_AGENDAMENTO}
                  EmpresaLocais={EmpresaLocais}
                  EmpresaStatus={EmpresaStatus}
                  HorarioAgendado={!_.isNull(HorarioAgendado) ? HorarioAgendado[idagendamento] : []}
                  TagsAgendamento={TagsAgendamento}
                  TagsPessoa={TagsPessoa}
                  xappRouteParams={xappRouteParams}
                  getBaseFiltro={getBaseFiltro}
                  saveAgendamentoPessoa={saveAgendamentoPessoa}
                  view={view}
                  form={form}
                  get={get}
                  save={save}
                  callback={callback}
                  user={user}
                  openContent={openContent}
               />
            )}
         </React.Fragment>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         showMessage: AppActions.showMessage,
         get: Actions.get,
         saveAgendamentoPessoa: Actions.saveAgendamentoPessoa,
         getBaseFiltro: Actions.getBaseFiltro,
         save: Actions.save,
         getHorarioAgendado: Actions.getHorarioAgendado,
         openDialog: Actions.openDialog,
         clearReducer: Actions.clearReducer,
      },
      dispatch
   );
}

function mapStateToProps({ AgendamentoEdicao, auth, Agendamento, MinhasTarefas }) {

   let TagsAgendamento = null;
   let TagsPessoa = null;
   if (!_.isUndefined(Agendamento)) {
      TagsAgendamento = Agendamento.TagFuncionalidadeReducer["agendamento"];
      TagsPessoa = Agendamento.TagFuncionalidadeReducer["pessoa"];
   }
   else if (!_.isUndefined(MinhasTarefas)) {
      TagsAgendamento = MinhasTarefas.TagFuncionalidadeReducer["agendamento"];
      TagsPessoa = MinhasTarefas.TagFuncionalidadeReducer["pessoa"];
   }

   return {
      user: auth.user.data,
      AgendamentoEdicao: AgendamentoEdicao,
      EmpresaLocais: AgendamentoEdicao.locaisempresa,
      EmpresaPessoaProduto: AgendamentoEdicao.pessoasprodutosempresa,
      dialog: AgendamentoEdicao.dialog,
      dadosresponsavel: AgendamentoEdicao.dadosresponsavel,
      HorarioAgendado: AgendamentoEdicao.horarioagendado,
      TagsAgendamento: TagsAgendamento,
      TagsPessoa: TagsPessoa,
   };
}

export default withReducer(
   "AgendamentoEdicao",
   reducer
)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AgendamentoEdicaoApp))));
